import SingleArticle from "./components/SingleArticle";

const Single = () => {
 
  return (
    <>
     <SingleArticle isBlog={true} />
    </>
  );
};

export default Single;
